<template>
  <div class="tuolele-main-box sort-management">
    <el-table
      :data="tableData"
      :row-key="getRowKeys"
      :expand-row-keys="expands"
      :row-class-name="tableRowClassName"
      border
      default-expand-all
      :tree-props="{ children: '_child', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="directory_name" label="分类名称" />
      <el-table-column prop="sortId" label="排序" />
      <el-table-column
        prop="article_count"
        label="包含内容数"
      />
      <el-table-column label="操作" width="400">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.rank == '1' || scope.row.rank == '2'"
            type="text"
            @click="improveDirectory(scope.row)"
          >新建下级</el-button>
          <el-button
            v-if="scope.row.rank != '1'"
            type="text"
            @click="sortDirectory(scope.row)"
          >排序</el-button>
          <el-button
            v-if="scope.row.rank != '1'"
            type="text"
            @click="editDirectory(scope.row)"
          >编辑</el-button>
          <el-button
            v-if="scope.row.rank != '1'"
            class="el-button--delete"
            type="text"
            @click="deleteDirectory(scope.row)"
          >删除</el-button>
          <el-button
            type="text"
            @click="directoryDetail(scope.row)"
          >查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'SortManagement',
  components: {},
  data() {
    return {
      tableData: [],
      // 获取row的key值
      getRowKeys(row) {
        return row.id
      },
      // 要展开的行，数值的元素是row的key值
      expands: [],
      child: []
    }
  },
  mounted() {
    this.getDirectoryListTree()
  },
  methods: {
    getDirectoryListTree() {
      const params = {}
      this.$http.getDirectoryListTree(params).then(res => {
        this.tableData = res.data
        this.tableData.map((value, index) => {
          value.rank = 1
          value.sortId = index + 1
          if (value._child == undefined) {
            value.child = 0
          } else {
            value.child = value._child.length
            value._child.map((t, i) => {
              t.rank = 2
              t.sortId = value.sortId + '.' + (i + 1)
              if (t._child != undefined) {
                t._child.map((v, j) => {
                  v.rank = 3
                  v.sortId = t.sortId + '.' + (j + 1)
                })
              }
            })
          }
        })
      })
    },
    // 资料 点击排序
    sortDirectory(row) {
      this.$prompt('移动到第', '排序', {
        showCancelButton: false,
        inputType: 'number',
        inputPattern: /^\+?[1-9]\d*$/
      }).then(({ value }) => {
        const params = {
          id: row.id,
          sort: value
        }
        this.$http.setDirectorySort(params).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '移动到: 第' + value + '位成功'
            })
            this.getDirectoryListTree()
          }
        })
      })
    },
    improveDirectory(row) {
      this.$prompt('分类名称', '新增子分类', {
        showCancelButton: false
      }).then(({ value }) => {
        if (!value) {
          return
        }
        let sort = 1
        if (row._child) {
          sort = row._child.length + 1
        }
        const params = {
          // id: "", // 要编辑的目录ID，不传则新增
          directory_name: value, // 目录名字
          pid: row.id, // 上级目录ID
          sort: sort
        }
        this.$http.improveDirectory(params).then(res => {
          console.log(res)
          this.getDirectoryListTree()
        })
      })
    },
    editDirectory(row) {
      this.$prompt('分类名称', '编辑子分类', {
        showCancelButton: false,
        inputValue: row.directory_name
      }).then(({ value }) => {
        const params = {
          id: row.id, // 要编辑的目录ID，不传则新增
          directory_name: value, // 目录名字
          pid: row.pid // 上级目录ID
        }
        this.$http.improveDirectory(params).then(res => {
          console.log(res)
          this.getDirectoryListTree()
        })
      })
    },
    deleteDirectory(row) {
      const params = {
        id: row.id // 资料id
      }
      this.$confirm('确定要移除当前选择的内容吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        this.$http.getDirectoryRemove(params).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.getDirectoryListTree()
          }
        })
      })
    },
    directoryDetail(row) {
      this.$router.push({
        path: 'sortManagementDetail',
        query: { id: row.id }
      })
    },
    tableRowClassName({ row }) {
      if (row.rank == 1) {
        return 'first-row'
      } else if (row.rank == 2) {
        return 'second-row'
      }
    }
  }
}
</script>

<style lang="scss">
.sort-management {
  .el-table {
    border: 1px solid #f1f1f1;
  }
  .el-table .first-row {
    background: #f1f1f1 !important;
  }
  .el-table .second-row {
    background: #f9f9f9 !important;
  }
  .el-message-box__title {
    color: $color_blue !important;
  }
  .el-table--border td,
  .el-table--border th {
    border-right: none !important;
    border-bottom: 1px solid #e4e6e8 !important;
  }
  .el-table__row--level-0 td:first-child div {
    color: #333 !important;
    font-weight: bold;
  }
  .el-table tr td:first-child {
    text-align: left !important;
  }
  .el-table__row--level-1 td:first-child div {
    color: #4a4a4a !important;
  }
  .el-table__row--level-2 td:first-child div {
    color: #999 !important;
  }
  .el-table__row td:first-child div {
    margin-left: 15px;
  }
}
</style>
